import { crohamBaseTheme } from './themeConfig/crohamBase';

/** Croham client — Sisu Forge hub (Travel Buddy + crypto tax) lives in `sisuforge/`. */
export const theme = crohamBaseTheme;
